import axios from 'axios';
import { SLACK_URL } from './http';

const makeInformation = json => {
  const { error, info } = json;
  const newInformation = [];
  newInformation.push({
    type: 'section',
    text: {
      type: 'mrkdwn',
      text: JSON.stringify(error.stack)
    }
  });
  newInformation.push({
    type: 'section',
    text: {
      type: 'mrkdwn',
      text: JSON.stringify(info.componentStack)
    }
  });
  return { text: JSON.stringify(newInformation) };
};

const sentToSlack = async json => {
  const info = makeInformation(json);
  try {
    const res = await axios.post(`${SLACK_URL}`, JSON.stringify(info));
    let { data } = await res;
    return data;
  } catch (err) {
    const {
      response: { data }
    } = await err;
    throw data;
  }
};

const LogError = {
  sentToSlack
};

export default LogError;
